import React from "react";
import "./PortfolioItem.css";

function PortfolioItem({ src, title, subtitle }) {
  return (
    <div className="portfolio-item">
      <img src={src} alt={title} />
      <div className="portfolio-overlay">
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
    </div>
  );
}

export default PortfolioItem;
